'use client'
import React, {useEffect, useState} from "react";

import { Button, Col, Container, Row } from "components/ui";
import DOMPurify from 'dompurify';
import {useTekstClient} from "hooks/useTekstClient";
import Skeleton from "components/Skeleton/Skeleton";
import {BsFillBellFill} from "react-icons/bs";
import {MdArrowForwardIos} from "react-icons/md";
import { FaEnvelope, FaUnlock } from "react-icons/fa";
import Tegel from "components/Tegels/Tegel/Tegel";
import {useFormTitle} from "../../../../../../hooks/useFormTitle";
import {useAxios} from "../../../../../../hooks/useAxios";
import LocalizedLinkClient from "components/LocalizedLink/LocalizedLinkClient";
import classes from "../../../../../../components/SearchBar/search-bar.module.scss";
import useGebruiker from "../../../../../../hooks/useGebruiker";

const Contact = () => {
    const [mkgAlgemeenisLoading, setAlgemeenisLoading] = useState(true);
    const [mkg5isLoading, setMkg5isLoading] = useState(true);
    const [mkg3isLoading, setMkg3isLoading] = useState(true);
    const [mkg004isLoading, setMkg004isLoading] = useState(true);
    const [mkgAppisLoading, setMkgAppisLoading] = useState(true);
    const [mkgAlgemeenItems, setAlgemeenItems] = useState([]);
    const [mkg5Items, setMkg5Items] = useState([]);
    const [mkg3Items, setMkg3Items] = useState([]);
    const [mkg004Items, setMkg004Items] = useState([]);
    const [mkgAppItems, setMkgAppItems] = useState([]);
    const {tekst } = useTekstClient()
    const {formTitle} = useFormTitle()
    const {get} = useAxios();
    const {ingelogdeGebruiker} = useGebruiker()

    useEffect(() => {
        get(`wiki/veelgestelde-vragen`, {
            params: {
                aantalPerPagina: 4,
                algemeen: true
            }
        })
            .then((result) => {
                setAlgemeenisLoading(false)
                setAlgemeenItems(result.data.data);
            });

        get(`wiki/veelgestelde-vragen`, {
            params: {
                aantalPerPagina: 4,
                product: [1]
            }
        })
            .then((result) => {
                setMkg5isLoading(false)
                setMkg5Items(result.data.data);
            });

        get(`wiki/veelgestelde-vragen`, {
            params: {
                aantalPerPagina: 4,
                product: [2]
            }
        })
            .then((result) => {
                setMkg3isLoading(false)
                setMkg3Items(result.data.data);
            });

        get(`wiki/veelgestelde-vragen`, {
            params: {
                aantalPerPagina: 4,
                product: [3]
            }
        })
            .then((result) => {
                setMkg004isLoading(false)
                setMkg004Items(result.data.data);
            });

        get(`wiki/veelgestelde-vragen`, {
            params: {
                aantalPerPagina: 4,
                product: [4]
            }
        })
            .then((result) => {
                setMkgAppisLoading(false)
                setMkgAppItems(result.data.data);
            });
    }, []);


    return (
        <Container fluid="md" className="ps-5 max-w-[1140px]">
            <Row className="pb-3">
                <Col><b>{tekst('pagina:support:contact:titel')}</b></Col>
            </Row>
            <Row>
                <Col sm={5} md={5} lg={4} xl={4}>
                    <Tegel
                        imageurl='/media/Support/storingsdienst.svg'
                        titel={tekst('pagina:support:contact:helpdesk:titel')}
                        tekst={
                            <div>
                                <a href="tel:+310742566763" className="asLink"><b>+31 (0)74 - 25 66 763</b></a><br/>
                                {tekst('pagina:support:contact:helpdesk:openingstijden')} <br/>
                                <br/>
                                <a href="mailto:helpdesk@mkg.nl" className="asLink" style={{display: "flex", flexDirection: "row"}}>
                                    <FaEnvelope style={{marginTop: "auto", marginBottom: "auto", marginRight: "10px"}}/><b>helpdesk@mkg.nl</b></a><br/>
                                <br/>
                                {tekst('pagina:support:contact:helpdesk:melding_tekst')}<br/>
                                <br/>
                                {/*<a href="https://mkg.topdesk.net" >*/}
                                {/*    <div  className="btn-primary btn-250 append-right-arrow" >
                                <i className="fas fa-bell pr-2" />
                                { tekst('pagina:support:contact:helpdesk:melding_btn') }</div>*/}
                                {/*</a>*/}

                                {((ingelogdeGebruiker?.groep?.mkger || [6, 17].includes(ingelogdeGebruiker?.groep?.id) ||
                                    ingelogdeGebruiker?.meldingenbeheer) && ingelogdeGebruiker?.toonklantenkaart) ?
                                    <a href="/mijn-mkg/mijn-gegevens/meldingenbeheer" className="no-underline hover:no-underline" style={{textDecoration: "none"}}>
                                        <Button variant="primary" className="font-bold" style={{width: "250px", display: "flex", flexDirection: "row", gap: "20px"}}>
                                            <span style={{marginTop: "auto", marginBottom: "auto"}}><BsFillBellFill/></span>
                                            <span style={{fontWeight: 700}}>{tekst('pagina:menu:SearchBar:Maak een melding')}</span>
                                            <span style={{marginTop: "auto", marginBottom: "auto", marginLeft: "30px"}}><MdArrowForwardIos/></span>
                                        </Button>
                                    </a>: <a href="https://mkg.topdesk.net" className="no-underline hover:no-underline" style={{textDecoration: "none"}}>
                                        <Button variant="primary" className="font-bold" style={{width: "250px", display: "flex", flexDirection: "row", gap: "20px"}}>
                                            <span style={{marginTop: "auto", marginBottom: "auto"}}><BsFillBellFill/></span>
                                            <span style={{fontWeight: 700}}>{tekst('pagina:menu:SearchBar:Maak een melding')}</span>
                                            <span style={{marginTop: "auto", marginBottom: "auto", marginLeft: "30px"}}><MdArrowForwardIos/></span>
                                        </Button>
                                    </a>}

                            </div>
                        }
                        outsideReact={true}
                        url={null}
                        arrow={false}
                    />
                </Col>
                <Col sm="auto" md="auto" lg="auto" xl="auto" className="d-xs-none d-sm-block px-0 mx-2 mx-lg-3 mx-xl-3"
                     style={{borderLeft: "1px solid #eeeeee"}}/>
                <Col>
                    <h3>{tekst('pagina:support:contact:veelgestelde vragen')}</h3>
                    <h4 className="pt-2">Algemeen</h4>
                    {mkgAlgemeenisLoading ?
                        <React.Fragment>
                            <Skeleton classes="pb-3" minWidth={"80%"} style={{minHeight: "1.4rem"}}/>
                            <Skeleton classes="pb-3" minWidth={"65%"} style={{minHeight: "1.4rem", width: "65%"}}/>
                            <Skeleton classes="pb-3" minWidth={"90%"} style={{minHeight: "1.4rem"}}/>
                            <Skeleton classes="pb-3" style={{minHeight: "1.4rem"}}/>
                        </React.Fragment>
                        :
                        mkgAlgemeenItems.length > 0 ?
                            <ul>
                                {mkgAlgemeenItems.map((x, i) => <li key={'mkg5li' + i}>{x.autorisatie > 0 ?
                                    <FaUnlock style={{marginTop: "auto", marginBottom: "auto", marginRight: " 5px"}} title="Alleen toegekende items weergeven"/>: ''}
                                    <LocalizedLinkClient key={'mkg5link' + i} href={`/mijn-mkg/support/kenniscentrum/id/${x.id}/
                                    ${formTitle(x.content_gepubliceerd.titel)}`} dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(x.content_gepubliceerd.titel)}}/>
                                </li>)}
                            </ul>
                            : tekst('algemeen:geen data gevonden')
                    }


                    <h4 className="pt-3">MKG5</h4>
                    {mkg5isLoading ?
                        <React.Fragment>
                            <Skeleton classes="pb-3" minWidth={"80%"} style={{minHeight: "1.4rem"}}/>
                            <Skeleton classes="pb-3" minWidth={"65%"} style={{minHeight: "1.4rem", width: "65%"}}/>
                            <Skeleton classes="pb-3" minWidth={"90%"} style={{minHeight: "1.4rem"}}/>
                            <Skeleton classes="pb-3" style={{minHeight: "1.4rem"}}/>
                        </React.Fragment>
                        :
                        mkg5Items.length > 0 ?
                            <ul>
                                {mkg5Items.map((x, i) => <li key={'mkg5li' + i}>{x.autorisatie > 0 ?
                                    <i className="fas fa-unlock mr-2"
                                       title="Alleen toegekende items weergeven"/> : ''}<LocalizedLinkClient key={'mkg5link' + i}
                                          href={`/mijn-mkg/support/kenniscentrum/id/${x.id}/${formTitle(x.content_gepubliceerd.titel)}`}
                                  dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(x.content_gepubliceerd.titel)}}/>
                                </li>)}
                            </ul>
                            : tekst('algemeen:geen data gevonden')
                    }

                    <h4 className="pt-3">MKG3</h4>
                    {mkg3isLoading ?
                        <React.Fragment>
                            <Skeleton classes="pb-3" minWidth={"80%"} style={{minHeight: "1.4rem"}}/>
                            <Skeleton classes="pb-3" minWidth={"65%"} style={{minHeight: "1.4rem", width: "65%"}}/>
                            <Skeleton classes="pb-3" minWidth={"90%"} style={{minHeight: "1.4rem"}}/>
                            <Skeleton classes="pb-3" style={{minHeight: "1.4rem"}}/>
                        </React.Fragment>
                        :
                        mkg3Items.length > 0 ?
                            <ul>
                                {mkg3Items.map((x, i) => <li key={'mkg3li' + i}>{x.autorisatie > 0 ?
                                    <i className="fas fa-unlock mr-2"
                                       title="Alleen toegekende items weergeven"/> : ''}<LocalizedLinkClient key={'mkg3link' + i}
                                href={`/mijn-mkg/support/kenniscentrum/id/${x.id}/${formTitle(x.content_gepubliceerd.titel)}`}
                                dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(x.content_gepubliceerd.titel)}}/>
                                </li>)}
                            </ul>
                            : tekst('algemeen:geen data gevonden')
                    }

                    <h4 className="pt-3">MKGApp</h4>
                    {mkgAppisLoading ?
                        <React.Fragment>
                            <Skeleton classes="pb-3" minWidth={"80%"} style={{minHeight: "1.4rem"}}/>
                            <Skeleton classes="pb-3" minWidth={"65%"} style={{minHeight: "1.4rem", width: "65%"}}/>
                            <Skeleton classes="pb-3" minWidth={"90%"} style={{minHeight: "1.4rem"}}/>
                            <Skeleton classes="pb-3" style={{minHeight: "1.4rem"}}/>
                        </React.Fragment>
                        :
                        mkgAppItems.length > 0 ?
                            <ul>
                                {mkgAppItems.map((x, i) => <li key={'mkg004li' + i}>{x.autorisatie > 0 ?
                                    <i className="fas fa-unlock mr-2"
                                       title="Alleen toegekende items weergeven"/> : ''}<LocalizedLinkClient key={'mkg004link' + i}
                              href={`/mijn-mkg/support/kenniscentrum/id/${x.id}/${formTitle(x.content_gepubliceerd.titel)}`}
                               dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(x.content_gepubliceerd.titel)}}/>
                                </li>)}
                            </ul>
                            : tekst('algemeen:geen data gevonden')
                    }
                </Col>
            </Row>


        </Container>
    )
}
export default Contact;